export enum MeetingProposalStatus {
    PendingSellerAnswer = 1,
    PendingBuyerAnswer = 2,
    Confirmed = 3,
}

export const MeetingProposalStatusOptions = {
    [MeetingProposalStatus.PendingSellerAnswer]: 'Pending Seller Answer',
    [MeetingProposalStatus.PendingBuyerAnswer]: 'Pending Buyer Answer',
    [MeetingProposalStatus.Confirmed]: 'Confirmed',
};